import React, { useContext } from "react";
import { MedicInformationContext } from "../../context/MedicInformationContextProvider";
import {
  HeartIcon,
  cardItemPerfilPacienteStyles,
  h5PerfilPacienteStyles,
  pPerfilPacienteStyles,
} from "../CustomStyle";
import { condicionesIcon } from "../imagepath";

const PatientsMedicCondition = () => {
  const { afiliadoComorbilidades } = useContext(MedicInformationContext);

  return (
    <div className="card-body">
      <div className="heading">
        <div className="heading-detail">
          <img src={condicionesIcon} width="20px" height="20px" />
          <h4>Condiciones médicas adicionales</h4>
        </div>
      </div>
      <div className="body-data">
        {afiliadoComorbilidades.map((condition, index) => (
          <div key={index} style={cardItemPerfilPacienteStyles}>
            <h5 style={h5PerfilPacienteStyles}>
              <HeartIcon />
              {condition.descripcion}
            </h5>
            <p style={pPerfilPacienteStyles}>{condition.fecha}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PatientsMedicCondition;
